import React, { Component } from 'react';

export class FormUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFiles: null,
      uploadStatus: '',  // Estado para armazenar a mensagem de status
      uploadProgress: 0, // Estado para o progresso do upload
    };
    this.fileInputRef = React.createRef();
  }

  handleFileChange = (event) => {
    this.setState({ selectedFiles: event.target.files });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { selectedFiles } = this.state;
    if (selectedFiles.length > 0) {
      this.onUpload(selectedFiles); 
    } else {
      alert('Por favor, selecione algum arquivo para enviar.');
    }
  };
  
  onUpload = async (files) => { 
    const formData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('files', files[i]);
    }

    const xhr = new XMLHttpRequest();
    xhr.open('POST', '/api/Container/uploadFile', true);

    // Rastreando o progresso do upload
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        this.setState({ uploadProgress: percentComplete });
      }
    };

    xhr.onload = () => {
      if (xhr.status === 200) {
        this.setState({
          uploadStatus: 'Arquivos enviados com sucesso!',
          uploadProgress: 0, // Resetar o progresso após o upload ser completado
        });
        this.fileInputRef.current.value = ''; // Limpar o input do arquivo
      } else {
        this.setState({ uploadStatus: 'Falha ao fazer upload dos arquivos.' });
      }
    };

    xhr.onerror = () => {
      this.setState({ uploadStatus: 'Erro ao enviar arquivos.' });
    };

    xhr.send(formData);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.uploadStatus !== this.state.uploadStatus) {
      console.log('Upload Status:', this.state.uploadStatus);
    }
  }

  render() {
    const { uploadStatus } = this.state;
    const statusColor = uploadStatus === 'Arquivos enviados com sucesso!' ? 'green' : 'red';

    return (
      <div className="form-upload-container">
        <h1>Upload de Arquivos para Eridashboard NROC</h1>
        <form onSubmit={this.handleSubmit}>
          <div>
            <label htmlFor="file-upload">Selecione os arquivos:</label>
            <input
              type="file"
              id="file-upload"
              name="file-upload"
              onChange={this.handleFileChange}
              multiple 
              ref={this.fileInputRef}
              style={{ display: 'block', margin: '10px 0' }}
            />
          </div>
          <button type="submit">Enviar Arquivos</button>
          {uploadStatus && (
            <div style={{ margin: '10px 0', fontWeight: 'bold', color: statusColor }}>
              {uploadStatus}
            </div>
          )}
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/arquivos/FormUpload.js